import { useCallback, useSyncExternalStore } from "react";

const KEY = "feather_watchlist";
let listeners = [];
const read = () => localStorage.getItem(KEY) || "[]";

const subscribe = (cb) => {
  listeners.push(cb);
  return () => { listeners = listeners.filter((l) => l !== cb); };
};

export function useWatchlist() {
  const raw = useSyncExternalStore(subscribe, read);
  const items = JSON.parse(raw);

  const toggle = useCallback((item) => {
    const cur = JSON.parse(localStorage.getItem(KEY) || "[]");
    const exists = cur.find((i) => i.id === item.id && i.type === item.type);
    const next = exists ? cur.filter((i) => !(i.id === item.id && i.type === item.type)) : [...cur, { ...item, added_at: Date.now() }];
    localStorage.setItem(KEY, JSON.stringify(next));
    listeners.forEach((l) => l());
  }, []);

  const has = useCallback((type, id) => items.some((i) => i.id === id && i.type === type), [items]);
  return { items, toggle, has };
}
